import React from 'react';
import classNames from 'classnames';
import { ControllerFieldState, ControllerRenderProps, FieldPath, FieldValues } from 'react-hook-form';
import { ErrorMessage } from './ErrorMessage';

interface IProps<TFieldValues extends FieldValues = FieldValues, TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>> extends React.HTMLAttributes<HTMLDivElement> {
	label?: string;
	labelClassName?: string;
	required?: boolean;
	field?: ControllerRenderProps<TFieldValues, TName>;
	fieldState?: ControllerFieldState;
}

export function FormGroup<TFieldValues extends FieldValues = FieldValues, TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>>(props: IProps<TFieldValues, TName>) {
	const { children, label, labelClassName , className, field, fieldState, ...otherProps } = props;
	return (
		<div className={classNames({ 'mb-3': !className?.includes('mb-') }, className)} {...otherProps}>
			<div className="d-flex justify-content-between ">
				{label && <label htmlFor={field?.name} className={classNames('form-label', labelClassName)}>{label}</label>}
				{props.required && (
					<span className="d-block ms-2 label-required">Required</span>
				)}
			</div>
			<div className="input-container">
				{children}
			</div>
			<ErrorMessage className="mt-3" fieldState={fieldState} />
		</div>
	);
}
